function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

// Set CSS variables for scrollbar width and header height
let announcementHeight= 0;
function setScrollbarWidth() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

function setHeaderHeight() {
  const header = document.querySelector(".header");
  const announcement = document.querySelector(".announcement-bar");
  if (header) {
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--announcement-height', `${announcement?.offsetHeight || 0}px`);
    announcementHeight = announcement?.offsetHeight;
  }
}
// Header Sticky
function headerSticky() {
  
  if (window.scrollY > announcementHeight){
    document.body.style.setProperty('--sticky-header-height', `0px`);
  } else {
    document.body.style.setProperty('--sticky-header-height', `${announcementHeight - window.scrollY}px`);
  }
  // if (window.scrollY > announcementHeight){
  //   console.log(window.scrollY,'------', announcementHeight);
  //   document.querySelector(".header-section")?.classList.add('sticky-header');
  // } else {
  //   document.querySelector(".header-section")?.classList.remove('sticky-header');
  // }  
}
document.addEventListener("scroll", (event) => {
  headerSticky();
});
setScrollbarWidth();
setHeaderHeight();
headerSticky();
window.addEventListener('resize', () => {
  setScrollbarWidth();
  setHeaderHeight();
  headerSticky();
});

// Initialize Swipers
new Swiper('.announcement', {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.announcement-button-next',
    prevEl: '.announcement-button-prev',
  },
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  }
});

new Swiper(".hero-banner-swiper", {
  loop: true,
  slidesPerView: 1,
  pagination: {
    el: '.banner-pagination',
      clickable: true,
      renderBullet: function (index, className) {
      return `<span class="${className}"><div class="swiper-pagination-loader"></div></span> `;
    },
  },
  autoplay: {
    delay: 4000,
  },
  navigation: {
    nextEl: '.banner-button-next',
    prevEl: '.banner-button-prev',
  },
  on: {
    slideChange: function (swiper) {
      pauseAllMedia();
      const activeSlide = swiper.slides[swiper.activeIndex];
      playMediaInSlide(activeSlide);
    }
  }
});

new Swiper(".feature-col-swiper", {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 16,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    768: { slidesPerView: 'auto', spaceBetween: 20 },
    992: { slidesPerView: 4, spaceBetween: 20 },
    1280: { slidesPerView: 5, spaceBetween: 40 },
    1366: { slidesPerView: 5, spaceBetween: 20 },
    1500: { slidesPerView: 5, spaceBetween: 20 },
    1600: { slidesPerView: 5, spaceBetween: 20 },
  }
});

new Swiper(".image-lookbook-outer", {
  loop: false,
  slidesPerView: 1,
  breakpoints: {
    768: { slidesPerView: 2}
  },
  navigation: {
    nextEl: '.lookbook-btn-next',
    prevEl: '.lookbook-btn-prev',
  },
});

new Swiper(".icon-with-text-swiper", {
  loop: false,
  spaceBetween: 16,
  slidesPerView: 'auto',
  breakpoints: {
    575: { slidesPerView: 2 },
    768: { slidesPerView: 3, spaceBetween: 20 },
    992: { slidesPerView: 4, spaceBetween: 30 },
    1280: { slidesPerView: 4, spaceBetween: 40 },
    1366: { slidesPerView: 4, spaceBetween: 60 },
    1600: { slidesPerView: 4, spaceBetween: 80 },
  }
});

let sliderThumbs = null;
if (document.querySelector(".product-thumb-swier")) {
  sliderThumbs = new Swiper(".product-thumb-swier", {
    direction: "horizontal",
    slidesPerView: 'auto',
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    navigation: {
      nextEl: ".product-thumb-next",
      prevEl: ".product-thumb-prev"
    },
    freeMode: true,
    breakpoints: {
      0: { direction: "horizontal" },
      576: { slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
      768: {
        direction: "vertical",
        slidesPerView: 3,
        spaceBetween: 10,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      }
    }
  });
}

new Swiper(".product-gallery-swiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  // mousewheel: true,
  navigation: {
    nextEl: ".product-thumb-next",
    prevEl: ".product-thumb-prev"
  },
  grabCursor: true,
  thumbs: sliderThumbs ? { swiper: sliderThumbs } : undefined,
  breakpoints: {
    0: { slidesPerView: 1 },
    576: { slidesPerView: 1 },
    768: { slidesPerView: 1 }
  },
  on: {
    init: function (swiper) {
      document.querySelector('.product-slider-wpr')
        ?.style.setProperty('--gallery-slider-height', swiper.height + 'px');
    },
    slideChange: function (swiper) {
      pauseAllMedia();
      const activeSlide = swiper.slides[swiper.activeIndex];
      playMediaInSlide(activeSlide);
    }
  }
});

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function playMediaInSlide(slide) {
  if (!slide) return;
  
  const youtubeVideo = slide.querySelector('.js-youtube');
  if (youtubeVideo) {
    youtubeVideo.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
    youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
  
  const vimeoVideo = slide.querySelector('.js-vimeo');
  if (vimeoVideo) {
    vimeoVideo.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
    vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
  }
  
  const nativeVideo = slide.querySelector('video');
  if (nativeVideo) {
    nativeVideo.play().catch(err => console.log('Auto-play prevented:', err));
  }
  
  const model = slide.querySelector('product-model');
  if (model && model.modelViewerUI) {
    model.modelViewerUI.play();
  }
}

// new Swiper(".feature-col-swiper", {
//   loop: false,
//   slidesPerView: 'auto',
//   spaceBetween: 16,
//   breakpoints: {
//     768: { slidesPerView: 'auto', spaceBetween: 20 },
//     992: { slidesPerView: 4 },
//     1280: { slidesPerView: 5, spaceBetween: 60 },
//     1366: { slidesPerView: 5, spaceBetween: 70 },
//     1500: { slidesPerView: 5, spaceBetween: 85 },
//     1600: { slidesPerView: 5, spaceBetween: 108 },
//   }
// });
const mediaQuery991 = window.matchMedia('(max-width: 991px)');

// Global event delegation
document.addEventListener('click', (e) => {
  const target = e.target;

  // Mobile Menu toggle
  if (target.matches('.menu-hamburger')) {
    target.classList.toggle('active');
    document.querySelector('.header_wrapper > .menu-nav-wpr')?.classList.toggle('open');
  }

  // Mega Menu open (for small screens)
  if (target.closest('.has_mega_link')) {
    e.preventDefault();

    if (mediaQuery991.matches) {
      const menuItem = target.closest('.menu_item');
      const megaMenuOuter = menuItem?.querySelector('.mega-menu-outer');

      if (!menuItem || !megaMenuOuter) return;

      document.querySelectorAll('.header_menu .menu_item').forEach((item) => {
        if (item !== menuItem) {
          item.classList.remove('open');
          const otherMega = item.querySelector('.mega-menu-outer');
          if (otherMega) otherMega.style.maxHeight = '0px';
        }
      });

      if (!menuItem.classList.contains('open')) {
        menuItem.classList.add('open');
        megaMenuOuter.style.maxHeight =
          (megaMenuOuter.querySelector('.container').scrollHeight + megaMenuOuter.querySelector('.mega-links-wpr .mega-links-ul').scrollHeight + 30) + 'px';          
      } else {
        menuItem.classList.remove('open');
        megaMenuOuter.style.maxHeight = '0px';
      }
    }
  }

  // Mega Menu back button
  if (target.matches('.mega-menu-back .back-btn')) {
    target.closest('.mega-menu-outer')?.classList.remove('open');
  }

  // Search toggle
  if (target.matches('.header-icon-btn.search-btn')) {
    document.querySelector('.search-outer')?.classList.toggle('open');
  }

  if (target.matches('.search-icon-close')) {
    document.querySelector('.search-outer')?.classList.remove('open');
  }

  // Drawer open/close
  if (target.hasAttribute('data-open-popup')) {
    e.preventDefault();
    document.querySelector(target.getAttribute('data-open-popup'))?.classList.add('open');
  }

  if (target.hasAttribute('data-close-popup')) {
    e.preventDefault();
    document.querySelector(target.getAttribute('data-close-popup'))?.classList.remove('open');
  }

  // Overlay click
  if (target.matches('.black-overlay')) {
    // console.log(document.querySelector('.drawer-wpr'));
    
    // document.querySelector('')?.classList.remove('open');
    document.querySelector('.menu-hamburger')?.classList.remove('active');
    // document.querySelector('.search-outer')?.classList.remove('open');
    document.querySelectorAll('.drawer-wpr,.search-outer,.header_wrapper > .menu-nav-wpr,.mega-menu-outer')?.forEach(element => {
      element.classList.remove('open')
    });
    // document.querySelectorAll(".mega-menu-outer").forEach(item => item.classList.remove('open'));
  }

  // Accordion toggle
  // console.log(target);
  if (target.hasAttribute('data-accordion-title')) {
    
    const isActive = target.classList.contains('active');
    document.querySelectorAll('[data-accordion-title]').forEach(item => {
      item.classList.remove('active');
      item.nextElementSibling.style.maxHeight = null;
    });
    if (!isActive) {
      target.classList.add('active');
      target.nextElementSibling.style.maxHeight = target.nextElementSibling.scrollHeight + 'px';
    }
  }

 
  // if (target.closest('.load-more-btn')) {
  //   const btn = target.closest('.load-more-btn');
  //   e.preventDefault();
  //   const url = btn.dataset.nextProduct;
  //   if (url) {
  //     btn.disabled = true;
  //     btn.querySelector('span').textContent = 'Loading...';
  //     loadMore(url);
  //   }
  // }

  // if click happens outside the wrapper
  let sortFilter = document.querySelector('.sort-fltr-wpr')
  if (sortFilter && !sortFilter.contains(target)) {
    sortFilter.querySelector('.sort-fltr-btn').classList.remove('active');
    sortFilter.querySelector('.sort-value-body').style.maxHeight = null; 
  }

  if (target.matches('.size-guide-link')) {
    e.preventDefault();
    const drawer = document.querySelector('#SizeChartDrawer');
    drawer?.classList.add('open');
  }

  if (target.matches('#SizeChartDrawer .drawer__close')) {
    const drawer = document.querySelector('#SizeChartDrawer');
    drawer?.classList.remove('open');
  }

  if (target.matches('.read-more-action')) {
    const wrapper = target.closest('.read-more-wpr');
    wrapper?.classList.toggle('active');

    target.textContent = wrapper?.classList.contains('active')
      ? "Read less"
      : "Read more";
  }

});

// document.addEventListener('click', (e) => {
//   const target = e.target;
//   const title = target.closest('[data-accordion-title]');
//     if (title.hasAttribute('data-accordion-title')) {
//     const isActive = title.classList.contains('active');
//     document.querySelectorAll('[data-accordion-title]').forEach(item => {
//       item.classList.remove('active');
//       item.nextElementSibling.style.maxHeight = null;
//     });
//     if (!isActive) {
//       title.classList.add('active');
//       title.nextElementSibling.style.maxHeight = title.nextElementSibling.scrollHeight + 'px';
//     }
//   }
// });

 // load more 
// function loadMore(url, containerSelector = '[data-load-more-wrapper]', buttonWrapperSelector = '.load-more-wpr') {
//   fetch(url, { method: 'GET' })
//     .then((response) => response.text())
//     .then((html) => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');
      
//       const newItems = doc.querySelectorAll(`${containerSelector} > *`);
//       const container = document.querySelector(containerSelector);

//       newItems.forEach((el) => container.appendChild(el));

//       const newWrapper = doc.querySelector(buttonWrapperSelector);
//       const oldWrapper = document.querySelector(buttonWrapperSelector);

//       if (newWrapper && oldWrapper) {
//         oldWrapper.replaceWith(newWrapper);
//       } else if (!newWrapper && oldWrapper) {
//         oldWrapper.remove();
//       }
//     })
//     .catch((err) => {
//       console.error('Load more error:', err);
//     });
// }

class InfiniteScrollSentinel extends HTMLElement {
  connectedCallback() {
    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || this._loading) return;
          this._fetchNextPage();
        });
      },
      { rootMargin: '0px 0px 300px 0px' }
    );

    this._observer.observe(this);
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  get containerSelector() {
    return this.dataset.container ?? '[data-load-more-wrapper]';
  }

  _fetchNextPage() {
    const url = this.dataset.nextUrl;
    if (!url) return;

    this._loading = true;

    fetch(url, { method: 'GET' })
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const container = document.querySelector(this.containerSelector);
        doc.querySelectorAll(`${this.containerSelector} > *`)
           .forEach((el) => container.appendChild(el));

        const next = doc.querySelector('infinite-scroll-sentinel');

        if (next?.dataset.nextUrl) {
          this.dataset.nextUrl = next.dataset.nextUrl;
          this._loading = false;
        } else {
          this._observer.disconnect();
          this.remove();
        }
      })
      .catch((err) => {
        console.error('[infinite-scroll-sentinel] Fetch error:', err);
        this._loading = false;
      });
  }
}

customElements.define('infinite-scroll-sentinel', InfiniteScrollSentinel);